import React, { Fragment, useEffect, useState } from 'react';
import "./login.scss";
import { BallBeat } from '../../Loader/loader.js';
import { Snackbar } from '@mui/material';
import { userLogin, forgotPassword, resetPasswords } from '../../Redux/ActionCreators/authAction.js';
import { clearErrors } from '../../Redux/ActionCreators/errorAction.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import { useGoogleLogin } from '@react-oauth/google';


function Login() {
    const [defaultShowSignUp, setDefaultShowSignUp] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isResetPassword, setISResetPassword] = useState(false);
    const [resetPasswordComplete, setResetPasswordComplete] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [otpEmail, setOtpEmail] = useState('');
    const [isOtpEmailLoading, setIsOtpEmailLoading] = useState(false);
    const [otpEnable, setOtpEnable] = useState(false);
    const [emailOtpScreen, setEmailOtpScreen] = useState(true);
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [successEnable, setSuccessEnable] = useState(false);
    const [successMessageText, setSuccessMessageText] = useState('');
    const [responseStatus, setResponseStatus] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const googleLoginRedirect = useGoogleLogin({
        flow: 'auth-code',
        ux_mode: 'redirect',
        redirect_uri: window.location.origin + '/auth/google/callback',
    });

    const error = useSelector(state => state.error)
    useEffect(() => {
        if (location.state?.googleError) {
            setSuccessEnable(true);
            setSuccessMessageText(location.state.googleError);
        }
    }, [location.state]);

    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const authParam = params.get('auth');

        if (authParam === 'google' && !localStorage.getItem('token')) {
            localStorage.setItem('googleAuthSource', 'login');
            googleLoginRedirect();
            return;
        }

        if (authParam === 'linkedin' && !localStorage.getItem('token')) {
            localStorage.setItem('linkedInAuthSource', 'login');
            const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
            const redirectUri = encodeURIComponent(window.location.origin + '/auth/linkedin/callback');
            const scope = encodeURIComponent('openid profile email');
            window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
            return;
        }

        if (authParam === 'microsoft' && !localStorage.getItem('token')) {
            localStorage.setItem('microsoftAuthSource', 'login');
            const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
            const redirectUri = encodeURIComponent(window.location.origin + '/auth/microsoft/callback');
            const scope = encodeURIComponent('openid profile email');
            window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
            return;
        }

        if (window.location.href.includes('otp')) {
            setDefaultShowSignUp(false);
            setOtp(window.location.search.split("=")[1]);
        }


        if (localStorage.getItem('token')) {
            const details = JSON.parse(localStorage.getItem("profileDetails"));
            if (details?.roleId === "1") {
                (window.location.pathname === '/' || window.location.pathname === '/login') && (
                    navigate('/users')
                )
            }
            else {
                (window.location.pathname === '/' || window.location.pathname === '/login') && (
                    navigate('/jobs')
                )
            }

        } else {
            window.location.pathname === '/' && (
                navigate('/login')
            )
        }

    }, [])


    const onEmailChange = (e) => {
        setEmailError('');
        setEmail(e.target.value);
    }

    const onChangePassword = (e) => {
        setPasswordError('');
        setPassword(e.target.value);
    }


    const loginUser = async () => {
        setIsLoading(true);
        setResponseStatus('')
        let emailvalue = email;
        // eslint-disable-next-line no-useless-escape
        let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailvalue) {
            setEmailError('Email cant be blank');
            setIsLoading(false);
            return false;
        }
        else if (!emailrex.test(String(emailvalue))) {
            setEmailError("Email is not valid");
            setIsLoading(false);
            return false;
        }
        else if (password === "") {
            setPasswordError('Please enter password');
            setIsLoading(false);
        }
        else {
            let login = {
                emailId: email,
                password: btoa(password.toString())
            }

            const res = await dispatch(userLogin(login));
            if (res?.type === 'LOGIN_USER') {
                setTimeout(() => {
                    const details = JSON.parse(localStorage.getItem("profileDetails"));
                    if (details?.roleId === "1") {
                        navigate('/users');
                    } else {
                        navigate('/jobs');
                    }
                }, 1000);
            } else {
                setSuccessEnable(true);
                setSuccessMessageText("Wrong email or password");
            }
            setTimeout(() => {
                if (error.successMessage === false) {
                    setIsLoading(false);
                }
            }, 1000);

        }
    }

    // const loginOnKeyPress = async (e) => {
    //     if (e.which === 13 || e.keyCode === 13) {
    //         setIsLoading(true);
    //         setResponseStatus('')
    //         let emailvalue = email;
    //         // eslint-disable-next-line no-useless-escape
    //         let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //         if (!emailvalue) {
    //             setEmailError('Email cant be blank');
    //             setIsLoading(false);
    //             return false;
    //         }
    //         else if (!emailrex.test(String(emailvalue))) {
    //             setEmailError("Email is not valid");
    //             setIsLoading(false);
    //             return false;
    //         }
    //         else if (password === "") {
    //             setPasswordError('Please enter password');
    //             setIsLoading(false);
    //         }
    //         else {
    //             let login = {
    //                 emailId: email,
    //                 password: btoa(password.toString())
    //             }

    //             const res = await dispatch(userLogin(login));
    //             if (res?.type === 'LOGIN_USER') {
    //                 setTimeout(() => {
    //                     const details = JSON.parse(localStorage.getItem("profileDetails"));
    //                     if (details?.roleId === "1") {
    //                         navigate('/users');
    //                     } else {
    //                         navigate('/jobs');
    //                     }
    //                 }, 1000);
    //             }
    //             localStorage.getItem('token') !== null ?
    //                 navigate('/jobs')
    //                 : navigate('/login')
    //             setTimeout(() => {
    //                 if (error.successMessage === false) {
    //                     setIsLoading(false);
    //                 }
    //             }, 1000);

    //         }
    //     }
    // }

    const resetPassword = () => {
        setISResetPassword(true);
        setEmailError('');
    }

    const handleChange = otp => setOtp(otp);

    const onOtpEmailChange = (e) => {
        setEmailError('');
        setOtpEmail(e.target.value);
    }

    const handleOtpEmail = async () => {
        // eslint-disable-next-line no-useless-escape
        let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!otpEmail) {
            setEmailError(`Email can't be blank`);
            return false;
        }
        else if (!emailrex.test(String(otpEmail))) {
            setEmailError("Email is not valid");
            return false;
        }
        else {
            setIsOtpEmailLoading(true);
            await dispatch(forgotPassword(otpEmail));
            localStorage.setItem('email', otpEmail);
            await setIsOtpEmailLoading(false);
            await setOtpEnable(true);
            await setEmailOtpScreen(false);

        }
    }


    const onOtpEmailChangeKeyPress = async (e) => {
        // eslint-disable-next-line no-restricted-globals
        if (e.which === 13 || event.keyCode === 13) {
            // eslint-disable-next-line no-useless-escape
            let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!otpEmail) {
                setEmailError('Email cant be blank');
                return false;
            }
            else if (!emailrex.test(String(otpEmail))) {
                setEmailError("Email is not valid");
                return false;
            }
            else {
                setIsOtpEmailLoading(true);
                await dispatch(forgotPassword(otpEmail));
                localStorage.setItem('email', otpEmail);
                await setIsOtpEmailLoading(false);
                await setOtpEnable(true);
                await setEmailOtpScreen(false);

            }
        }
    }

    const handleOtpCheck1 = async () => {
        if (newPassword === "") {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter new password");
        }
        else if (confirmNewPassword === "") {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter confirm password");
        }
        else if (newPassword !== confirmNewPassword) {
            setSuccessEnable(true);
            setSuccessMessageText("Password did not match");
        }
        else if (otp.length < 6) {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter all the code fields");
        }
        else {
            setIsOtpEmailLoading(true);

            let obj = {
                "emailId": localStorage.getItem('email'),
                "passWord": btoa(newPassword.toString()),
                "otp": otp
            }

            const res = await dispatch(resetPasswords(obj));
            if (res?.type === 'RESET_PASSWORD') {
                await setResetPasswordComplete(true);
                await setIsOtpEmailLoading(false);
            }
        }
    }

    const onPasswordChange = async (e) => {
        // eslint-disable-next-line no-restricted-globals
        if (e.which === 13 || event.keyCode === 13) {
            if (newPassword === "") {
                setSuccessEnable(true);
                setSuccessMessageText("Please enter new password");
            }
            else if (confirmNewPassword === "") {
                setSuccessEnable(true);
                setSuccessMessageText("Please enter confirm password");
            }
            else if (newPassword !== confirmNewPassword) {
                setSuccessEnable(true);
                setSuccessMessageText("Password did not match");
            }
            else {
                setIsOtpEmailLoading(true);
                let obj = {
                    otp: otp,
                    password: btoa(newPassword.toString())
                }
            }
        }
    }

    const handleOtpCheck = async () => {
        if (newPassword === "") {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter new password");
        }
        else if (confirmNewPassword === "") {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter confirm password");
        }
        else if (newPassword !== confirmNewPassword) {
            setSuccessEnable(true);
            setSuccessMessageText("Password did not match");
        }

        else {
            setIsOtpEmailLoading(true);
            let obj = {
                otp: otp,
                password: newPassword
            }
            await setIsOtpEmailLoading(false);
        }
    }


    const handleGoogleClick = () => {
        localStorage.setItem('googleAuthSource', 'login');
        googleLoginRedirect();
    }

    const handleLinkedInClick = () => {
        localStorage.setItem('linkedInAuthSource', 'login');
        const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
        const redirectUri = encodeURIComponent(window.location.origin + '/auth/linkedin/callback');
        const scope = encodeURIComponent('openid profile email');
        window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
    }

    const handleMicrosoftClick = () => {
        localStorage.setItem('microsoftAuthSource', 'login');
        const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
        const redirectUri = encodeURIComponent(window.location.origin + '/auth/microsoft/callback');
        const scope = encodeURIComponent('openid profile email');
        window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
    }

    const redirectTologin = () => {
        window.location.reload()
    }




    const snackClosed = () => {
        dispatch(clearErrors());
        setSuccessEnable(false);
        setSuccessMessageText('')
    }

    const domainDetail = JSON.parse(localStorage.getItem('domainDetails'));

    return (
        <Fragment>
            <div className="row bg-img" style={{ background: `url('/images/bg-img1.png') no-repeat center center fixed`, height: '100vh', width: '100%', backgroundColor: '#fff', marginLeft: window.innerWidth > 767 ? 0 : 0 }} >
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={error.successMessage}
                    onClose={() => snackClosed()}
                    autoHideDuration={4000}
                >
                    <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                        {error.successMessageText}
                    </Alert>
                </Snackbar>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={error.successEnable}
                    onClose={() => snackClosed()}
                    autoHideDuration={4000}
                >
                    <Alert onClose={snackClosed} severity="success" sx={{ width: '100%' }}>
                        {error.successMessageText}
                    </Alert>
                </Snackbar>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => snackClosed()}
                    autoHideDuration={4000}
                >
                    <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                        {successMessageText}
                    </Alert>
                </Snackbar>

                {defaultShowSignUp ?
                    <div className='login-holder'>

                        {
                            isResetPassword === false ?
                                <Fragment>
                                    <div title={domainDetail !== null ? domainDetail?.displayName : 'Gappeo'} style={{ backgroundImage: `url(${domainDetail !== null ? domainDetail?.logoImage : '/images/gappeoai-logo.png'})`, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', width: '100%', height: 40 }}>

                                    </div>
                                    <h2 className='forgot-btn'>{`Welcome to ${domainDetail !== null ? domainDetail?.tenantName : "Gappeo"}`}</h2>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 20 }}>
                                        <button
                                            onClick={handleGoogleClick}
                                            disabled={isLoading}
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, width: 300, height: 40, background: '#fff', border: '1px solid #dadce0', borderRadius: 4, fontSize: 14, fontWeight: 500, color: '#3c4043', cursor: 'pointer', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
                                            Google
                                        </button>
                                        {/* <button
                                            onClick={handleLinkedInClick}
                                            disabled={isLoading}
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, width: 300, height: 40, background: '#0077B5', border: 'none', borderRadius: 4, fontSize: 14, fontWeight: 500, color: '#fff', cursor: 'pointer', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                                            LinkedIn
                                        </button> */}
                                        <button
                                            onClick={handleMicrosoftClick}
                                            disabled={isLoading}
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, width: 300, height: 40, background: '#2F2F2F', border: 'none', borderRadius: 4, fontSize: 14, fontWeight: 500, color: '#fff', cursor: 'pointer', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="9" height="9" fill="#F25022"/><rect x="11" y="1" width="9" height="9" fill="#7FBA00"/><rect x="1" y="11" width="9" height="9" fill="#00A4EF"/><rect x="11" y="11" width="9" height="9" fill="#FFB900"/></svg>
                                            Microsoft
                                        </button>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', margin: '16px 0 0' }}>
                                        <hr style={{ flex: 1, borderColor: '#ddd' }} />
                                        <span style={{ margin: '0 10px', color: '#888', fontSize: 13 }}>OR</span>
                                        <hr style={{ flex: 1, borderColor: '#ddd' }} />
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                        {
                                            <span style={{ fontWeight: 600, color: 'red', fontSize: 14, paddingTop: '5px', position: 'relative', marginBottom: -10 }}>{responseStatus}</span>
                                        }
                                        <div className="form-group mt-2">
                                            <div className="has-search"  >
                                                <span className="form-control-feedback" style={{ marginTop: 5 }}>
                                                    <img src="/images/email.png" alt='' />
                                                </span>
                                                <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder='Email' value={email} onChange={(e) => onEmailChange(e)}
                                                // onKeyPress={(e) => loginOnKeyPress(e)}
                                                />
                                            </div>
                                            <div className='error'>{emailError}</div>
                                        </div>
                                        <div className="form-group">
                                            <div className="has-search"  >
                                                <span className="form-control-feedback" >
                                                    <img src="/images/lock.png" alt='' />
                                                </span>
                                                <input type="password" className="form-control" aria-describedby="emailHelp" value={password} placeholder='Password' onChange={(e) => onChangePassword(e)}
                                                // onKeyPress={(e) => loginOnKeyPress(e)} 
                                                />
                                            </div>
                                            <div className='error'>{passwordError}</div>

                                        </div>
                                        {/* <a onClick={() => resetPassword()}>Forgot Password?</a> */}
                                        <div className='position-relative'>
                                            <button onClick={() => loginUser()} disabled={isLoading} className="login-button position-relative">
                                                {isLoading ? <BallBeat
                                                    color={'#fff'}
                                                    loading={true}
                                                /> : ("LOGIN")}
                                            </button>

                                        </div>
                                        <h2 className='forgot-btn my-3' onClick={resetPassword}>Forgot Password ?</h2>
                                        {/* {
                                            domainDetail?.isWhiteLabel === 1 ? null :
                                                <Fragment>
                                                    <p style={{ color: '#3D4143', fontSize: 14 }}>Need new account ?
                                                    </p>
                                                    <h2 className='forgot-btn mt-0' onClick={() => navigate('/signup')}>Sign up free</h2>
                                                </Fragment>
                                        } */}
                                    </div>
                                </Fragment>
                                :
                                <div className="login-holder otp-holder" style={{ width: '100%' }}>

                                    <h3>Reset your password .</h3>
                                    {
                                        otpEnable === false && emailOtpScreen ? <Fragment>
                                            <p className='mt-2'>Please enter your registered Email address .</p>
                                            <div className="form-group mt-3 w-100">
                                                <span>{responseStatus}</span>

                                                <input type="email" className="form-control" aria-describedby="emailHelp" placeholder='Email' onChange={(e) => onOtpEmailChange(e)} value={otpEmail}
                                                // onKeyPress={(e) => onOtpEmailChangeKeyPress(e)} 
                                                />
                                            </div>
                                            <div className='error'>{emailError}</div>
                                            <button onClick={() => handleOtpEmail()} className="primary-button position-relative">
                                                {isOtpEmailLoading ? <BallBeat
                                                    color={'#fff'}
                                                    loading={true}
                                                /> : ("CONTINUE")}</button>

                                        </Fragment> :

                                            resetPasswordComplete === false ?
                                                <div className="otp-fields d-flex flex-column align-items-center mt-3">
                                                    <p>Please enter the code that is sent to your mail.</p>
                                                    <div className="form-group">
                                                        <input type="text" placeholder='Enter Otp' className="form-control" autoComplete='off' onChange={(e) => handleChange(e.target.value)} />
                                                        <input type="password" placeholder='Enter new password' className="form-control" autoComplete='off' onChange={(e) => setNewPassword(e.target.value)} />
                                                        <input type="password" placeholder='Confirm new password' className="form-control" onChange={(e) => setConfirmNewPassword(e.target.value)} />
                                                    </div>

                                                    <button disabled={isOtpEmailLoading === false ? false : true} onClick={() => handleOtpCheck1()} className="primary-button position-relative">
                                                        {isOtpEmailLoading ? <BallBeat
                                                            color={'#fff'}
                                                            loading={true}
                                                        /> : "Reset"}</button>
                                                </div> : <div className="success-pasword-reset mt-2">
                                                    <p>Password has been successfully changed</p>
                                                    <button onClick={() => redirectTologin()} className="primary-button mt-2">Login</button>
                                                </div>
                                    }

                                </div>
                        }

                    </div> :
                    <div className="login-holder otp-holder">
                        <h3>Set your password</h3>
                        {
                            <div className="otp-fields" style={{ width: window.innerWidth > 767 ? '60%' : '90%' }}>
                                <p className='d-none'>Please enter the code that is sent to your mail.</p>
                                <input className='form-control d-none' onChange={(e) => handleChange(e.target.value)} style={{ height: 48 }} value={otp} />
                                <div className="form-group mt-3">
                                    <input type="password" placeholder='Enter new password' className="form-control" aria-describedby="emailHelp" onChange={(e) => setNewPassword(e.target.value)}
                                    // onKeyPress={(e) => onPasswordChange(e)} 
                                    />
                                    <input type="password" placeholder='Confirm new password' className="form-control" aria-describedby="emailHelp" onChange={(e) => setConfirmNewPassword(e.target.value)}
                                    // onKeyPress={(e) => onPasswordChange(e)} 
                                    />
                                </div>

                                <button disabled={isOtpEmailLoading !== false} onClick={() => handleOtpCheck()} className="primary-button position-relative">
                                    {isOtpEmailLoading ? <BallBeat
                                        color={'#fff'}
                                        loading={true}
                                    /> : "Set"}
                                </button>
                            </div>
                        }

                    </div>
                }
            </div>

        </Fragment>
    )
}


export default Login;